import type { ApiStorageTransaction } from '@Model';
import { Button, FlexColumn, FlexRow, TextInput } from '@synqo/frontend-component-library';
import { useState } from 'react';
import { StockPreviewLine } from '../StockPreviewLine';
import classes from './StorageTransactionCancelSection.module.css';
import { useCancelStorageTransaction } from './useCancelStorageTransaction';

interface IProps {
    booking: ApiStorageTransaction;
    /** Closes the section without cancelling. */
    onClose: () => void;
    /** Called after the booking was cancelled. */
    onCancelled: () => void;
}

/** Asks for the reason of a cancellation and shows what it does to the stock. A negative stock does not stop it. */
// @ai-generated 2026-10-26T16:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function StorageTransactionCancelSection({ booking, onClose, onCancelled }: IProps) {
    const [reason, setReason] = useState('');
    const { cancel, pending, errors } = useCancelStorageTransaction(booking.id);

    const submit = async () => {
        if (await cancel(reason)) {
            onCancelled();
        }
    };

    return (
        <FlexColumn className={classes.card} gap="none" align="stretch">
            <FlexColumn className={classes.body} align="stretch" gap="sm">
                <FlexRow className={classes.heading}>Buchung stornieren?</FlexRow>
                <FlexRow className={classes.hint}>
                    Eine Gegenbuchung zum selben Zeitpunkt hebt sie auf. Beide bleiben im Lagerjournal sichtbar.
                </FlexRow>
                <TextInput
                    name="reason"
                    value={reason}
                    onChange={(value) => {
                        setReason(value);
                        return true;
                    }}
                    label="Grund (optional)"
                    locked={pending}
                />
                <StockPreviewLine
                    storageLocationId={booking.storage_location.foreign_key}
                    materialId={booking.material.foreign_key}
                    avvId={booking.avv.foreign_key}
                    occurredAt={booking.occurred_at}
                    type={booking.type}
                    quantity={booking.quantity}
                    bookingId={booking.id}
                    view="cancellation"
                />
                {errors.map((error) => (
                    <FlexRow key={error} className={classes.error}>
                        {error}
                    </FlexRow>
                ))}
            </FlexColumn>
            <FlexRow className={classes.actions} justify="flex-end">
                <Button appearance="outlined" locked={pending} onClick={onClose}>
                    Abbrechen
                </Button>
                <Button variant="primary" locked={pending} onClick={submit}>
                    Stornieren
                </Button>
            </FlexRow>
        </FlexColumn>
    );
}
